// stores/user.js
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { userAPI, predictionAPI, nodeAPI, rewardAPI } from '@/utils/api'

export const useUserStore = defineStore('user', () => {
  const profile = ref(null)
  const predictions = ref([])
  const myPrediction = ref(null)
  const nodes = ref([])
  const nodeInfo = ref(null)
  const rewardSummary = ref(null)
  const isLoading = ref(false)

  // ✅ 计算属性：余额信息
  const balance = computed(() => ({
    virtual_uk_balance: parseFloat(profile.value?.statistics?.prediction_count || 0),
    virtual_usdt_balance: 0,
    uk_balance: parseFloat(profile.value?.total_prediction_value || 0),
  }))

  // ✅ 加载用户信息
  async function loadProfile() {
    try {
      const res = await userAPI.getProfile()
      profile.value = res.data || {}
      console.log('5555555555555555888888888',res.data)
      myPrediction.value =  res.data.total_prediction_value
      console.log('[user] loadProfile:', profile.value)
    } catch (e) {
      console.error('[user] loadProfile failed', e)
    }
  }

  // ✅ 加载预测记录（带字段映射）
  async function loadPredictions() {
    try {
      const res = await predictionAPI.getList({ status: -1, page: 1, page_size: 50 })
      console.log('[user] loadPredictions 原始数据:', res.data?.list)
      
      const list = res.data?.list || []
      
      // ✅ 字段映射和格式化
      predictions.value = list.map(pred => {
        // 解析 wei 单位的金额
        const usdtAmount = parseFloat(pred.usdtAmount || 0)
        const stakedUk = parseFloat(pred.stakedUk || 0)
        const entryPrice = parseFloat(pred.entryPrice || 0)
        const targetPrice = parseFloat(pred.targetPrice || 0)
        const ukSold = parseFloat(pred.ukSold || 0)
        const usdtReceived = parseFloat(pred.usdtReceived || 0)
        const forceSoldPrice = parseFloat(pred.forceSoldPrice || 0)
        
        return {
          // 原始字段
          id: pred.id,
          stakeId: pred.stakeId,
          userId: pred.userId,
          txHash: pred.txHash || pred.tx_hash,
          multiply: pred.multiply,
          status: pred.status,
          forceSold: pred.forceSold,
          
          // ✅ 格式化后的金额（从 wei 转换）
          usdtAmount: usdtAmount,
          principal_usdt: usdtAmount > 1e15 ? (usdtAmount / 1e18).toFixed(2) : usdtAmount.toFixed(2),
          
          stakedUk: stakedUk,
          staked_uk: stakedUk > 1e15 ? (stakedUk / 1e18).toFixed(2) : stakedUk.toFixed(2),
          
          incentiveUk: pred.incentiveUk,
          
          entryPrice: entryPrice,
          entry_price: entryPrice > 1e15 ? (entryPrice / 1e18).toFixed(6) : entryPrice.toFixed(6),
          
          targetPrice: targetPrice,
          target_price: targetPrice > 1e15 ? (targetPrice / 1e18).toFixed(6) : targetPrice.toFixed(6),
          
          // ✅ 预测值（已经是正常单位）
          predictionValue: parseFloat(pred.predictionValue || 0),
          prediction_value: parseFloat(pred.predictionValue || 0),
          
          // ✅ 兼容字段
          target_multiple: pred.multiply,
          
          // ✅ 时间字段
          createdAt: pred.createdAt,
          created_at: pred.createdAt,
          joinTime: pred.joinTime || pred.join_time,
          join_time: pred.joinTime || pred.join_time,
          
          // ✅ 强制卖出信息
          force_sold: pred.forceSold,
          forceSoldTime: pred.forceSoldTime,
          force_sold_time: pred.forceSoldTime,
          
          forceSoldPrice: forceSoldPrice,
          force_sold_price: forceSoldPrice > 1e15 ? (forceSoldPrice / 1e18).toFixed(6) : forceSoldPrice.toFixed(6),
          
          forceSoldTx: pred.forceSoldTx,
          force_sold_tx: pred.forceSoldTx,
          
          ukSold: ukSold,
          uk_sold: ukSold > 1e15 ? (ukSold / 1e18).toFixed(2) : ukSold.toFixed(2),
          
          usdtReceived: usdtReceived,
          usdt_received: usdtReceived > 1e15 ? (usdtReceived / 1e18).toFixed(2) : usdtReceived.toFixed(2),
        }
      })
      
      console.log('[user] loadPredictions 处理后:', predictions.value)
    } catch (e) {
      console.error('[user] loadPredictions failed', e)
    }
  }

  // ✅ 加载节点信息
  async function loadNodes() {
    try {
      const res = await nodeAPI.getMyNode()
      console.log('[user] loadNodes 原始数据:', res)
      
      const data = res.data || {}
      nodeInfo.value = data
      
      if (!data.is_node) {
        nodes.value = []
        return
      }
      
      const stats = data.statistics || {}
      const info = data.node_info || {}
      
      // 将后端返回的汇总数据转为前端节点卡片列表
      const records = data.node_records || (data.node_record ? [data.node_record] : [])
      
      if (records.length > 0) {
        // 按购买记录展开为多个节点卡片
        nodes.value = records.map((rec, idx) => {
          const ukPerRecord = rec.ukAmount || rec.uk_amount || '0'
          return {
            id: rec.id || idx + 1,
            node_status: 1,
            join_time: data.join_time,
            release_count: idx === 0 ? (info.releaseCount || 0) : 0,
            total_uk: ukPerRecord,
            released_uk: idx === 0 ? (stats.released_uk || '0') : '0',
            claimable_uk: idx === 0 ? (stats.claimable_uk || '0') : '0',
            claimed_uk: idx === 0 ? (stats.claimed_uk || '0') : '0',
            tx_hash: rec.txHash || rec.tx_hash,
            usdt_amount: rec.usdtAmount || rec.usdt_amount,
          }
        })
      } else {
        // 没有 record 但 is_node=true，用 node_info 汇总显示一条
        nodes.value = [{
          id: info.id || 1,
          node_status: 1,
          join_time: data.join_time,
          release_count: info.releaseCount || 0,
          total_uk: stats.total_uk || info.totalUk || '0',
          released_uk: stats.released_uk || '0',
          claimable_uk: stats.claimable_uk || '0',
          claimed_uk: stats.claimed_uk || '0',
        }]
      }
      
      console.log('[user] loadNodes 处理后:', nodes.value)
    } catch (e) {
      console.error('[user] loadNodes failed', e)
    }
  }

  // ✅ fetchNodes 作为 loadNodes 的别名
  const fetchNodes = loadNodes

  // ✅ 加载奖励汇总
  async function loadRewardSummary() {
    try {
      const res = await rewardAPI.getSummary()
      rewardSummary.value = res.data || {}
      console.log('[user] loadRewardSummary:', rewardSummary.value)
    } catch (e) {
      console.error('[user] loadRewardSummary failed', e)
    }
  }

  // ✅ 初始化所有数据
  async function initAll() {
    isLoading.value = true
    try {
      await Promise.allSettled([
        loadProfile(),
        loadPredictions(),
        loadNodes(),
        loadRewardSummary(),
      ])
    } finally {
      isLoading.value = false
    }
  }

  // ✅ 重置状态
  function reset() {
    profile.value = null
    predictions.value = []
    nodes.value = []
    nodeInfo.value = null
    rewardSummary.value = null
  }

  return {
    // 状态
    profile,
    balance,
    predictions,
    nodes,
    nodeInfo,
    rewardSummary,
    isLoading,
    myPrediction,
    
    // 方法
    loadProfile,
    loadPredictions,
    loadNodes,
    fetchNodes,
    loadRewardSummary,
    initAll,
    reset,
  }
})
